import Player from "./player/Player";

export default function App() {
  return (
    <div className="grid h-screen bg-[#202124]">
      <Player />
    </div>
  );
}